import { render } from "./PostponeModal.vue?vue&type=template&id=e26e1c50&scoped=true"
import script from "./PostponeModal.vue?vue&type=script&lang=js"
export * from "./PostponeModal.vue?vue&type=script&lang=js"

import "./PostponeModal.vue?vue&type=style&index=0&id=e26e1c50&scoped=true&lang=less"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e26e1c50"]])

export default __exports__